document.addEventListener('click', event => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('a[href]');
  if (!link) return;
  const destination = new URL(link.href, location.href);
  if (destination.origin !== location.origin) return;
  const menu = link.closest('.nn-mobile-menu');
  if (menu) menu.open = false;
  if (destination.hash !== '#nn-finder' && !destination.pathname.endsWith('/pages/book-your-holiday')) return;
  const current = new URL(location.href);
  for (const key of ['nb_arrival', 'nb_duration', 'nb_guests', 'nb_base', 'nb_month', 'nb_mode', 'preview_theme_id']) {
    if (!destination.searchParams.has(key) && current.searchParams.has(key)) destination.searchParams.set(key, current.searchParams.get(key));
  }
  link.href = destination.href;
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  for (const menu of document.querySelectorAll('.nn-mobile-menu[open]')) {
    menu.open = false;
    menu.querySelector('summary')?.focus();
  }
});
document.addEventListener('click', event => {
  if (!(event.target instanceof Element)) return;
  for (const menu of document.querySelectorAll('.nn-mobile-menu[open]')) if (!menu.contains(event.target)) menu.open = false;
});


